import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import params from '../config/Params';
import { getItemFromLocalStorage } from '../utils/storageUtils';
import jsPDF from 'jspdf';
import { toast } from 'react-toastify';

const DocumentViewer = () => {
  const { bookingId } = useParams();
  const [bookingCode, setBookingCode] = useState(null);
  const [documents, setDocuments] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [actionType, setActionType] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchBookingDetails = async () => {
      const hostData = getItemFromLocalStorage('hostProfile');
      let formData = new FormData();
      formData.append('token', hostData.host_access_token);
      formData.append('confirmation_code', bookingId);

      setLoading(true);
      try {
        const response = await axios({
          method: 'post',
          headers: {
            'Content-Type': 'multipart/form-data',
          },
          url: `${params.baseURL}${params.endpoints.getBookings}`,
          data: formData,
        });

        if (response.data.status === 'found') {
          setBookingCode(response.data.bookings.customer_documents.checkin_id);
          setDocuments(response.data.bookings.customer_documents);
        } else {
          setError('Booking not found.');
        }
      } catch (err) {
        setError('An error occurred while fetching booking details.');
      } finally {
        setLoading(false);
      }
    };

    fetchBookingDetails();
  }, [bookingId]);

  const handleDownloadPDF = async () => {
    const doc = new jsPDF('landscape', 'mm', 'a4');
  
    const loadImage = (url) =>
      new Promise((resolve) => {
        const img = new Image();
        img.crossOrigin = 'Anonymous';
        img.onload = () => resolve(img);
        img.src = url;
      });
  
    if (documents?.front && documents?.back) {
      const frontImg = await loadImage(documents.front);
      const backImg = await loadImage(documents.back);
  
      const pageWidth = doc.internal.pageSize.getWidth();
      const pageHeight = doc.internal.pageSize.getHeight();
  
      const imgWidth = pageWidth / 2 - 20;
      const imgHeightFront = (frontImg.height / frontImg.width) * imgWidth;
      const imgHeightBack = (backImg.height / backImg.width) * imgWidth;
      const maxHeight = Math.max(imgHeightFront, imgHeightBack);
  
      const yPos = (pageHeight - maxHeight) / 2;
  
      doc.addImage(frontImg, 'JPEG', 10, yPos, imgWidth, imgHeightFront);
      doc.addImage(backImg, 'JPEG', imgWidth + 30, yPos, imgWidth, imgHeightBack);
  
      doc.save('guest-document.pdf');
    }
  };  

  const confirmAction = (type) => {
    setActionType(type);
    setShowModal(true);
  };

  const handleConfirm = async () => {
    setShowModal(false);
    const hostData = getItemFromLocalStorage('hostProfile');
    let formData = new FormData();
    formData.append('token', hostData.host_access_token);
    formData.append('checkin_id', bookingCode);
    formData.append('status', actionType === 'accept' ? 1 : 2);

    try {
        const response = await axios({
            method: 'post',
            headers: {
              'Content-Type': 'multipart/form-data',
            },
            url: `${params.baseURL}${params.endpoints.verifyUserDocument}`,
            data: formData,
        });
        if (response.data.status === 'ok') {
            toast.success(`Document ${actionType === 'accept' ? 'accepted' : 'rejected'} successfully.`);
        } else {
            toast.error('Failed to update document status.');
        }
    } catch (err) {
        toast.error('Failed to update document status.');
    }
  };

  return (
    <div className="container mt-4">
      <h4 className='bd-title'>Guest Document</h4>
      {error && <p className="text-danger">{error}</p>}
      {loading && <p>Loading documents...</p>}
      {documents && (
        <>
          <div className="row mb-4">
            <div className="col-md-6">
              <p className='bd-desc'>Front Side</p>
              <img
                src={documents.front}
                alt="Front Document"
                className="img-fluid border"
              />
            </div>
            <div className="col-md-6">
              <p className='bd-desc'>Back Side</p>
              <img
                src={documents.back}
                alt="Back Document"
                className="img-fluid border"
              />
            </div>
          </div>
          <button className="btn btn-black w-100" onClick={handleDownloadPDF}>
            Download as PDF
          </button>

          <div className="d-flex gap-3 mt-4">
            <button className="btn btn-success w-100" onClick={() => confirmAction('accept')}>
              Accept
            </button>
            <button className="btn btn-danger w-100" onClick={() => confirmAction('reject')}>
              Reject
            </button>
          </div>
        </>
      )}

      {showModal && (
        <div className="confirmation-popup-overlay">
          <div className="confirmation-popup" style={{ width: '600px' }}>
            <div className="euc-box">
              <div className="popup-body" style={{ position: 'relative' }}>
                <img src={`/assets/img/icons/user_id_${actionType}.webp`} className="img-fluid" alt="" />
                <div className="euc-close" onClick={() => setShowModal(false)}>
                  <img src={'/assets/img/icons/popup_close.png'} className="img-fluid" alt="" />
                </div>
              </div>
              <div className="popup-subcnt" style={{padding: '10px 0', background : '#fff'}}>
                <div className="popup-options">
                  <div className="coupon-drawer-footer" style={{ display: 'flex', flexDirection : 'row', justifyContent: 'space-between', marginTop: '20px' }}>
                    <button className="btn btn-success" onClick={handleConfirm}>Yes</button>
                    <button className="btn btn-danger" onClick={() => setShowModal(false)}>No</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default DocumentViewer;
